/**
 * Streams the viewer waved off — auto-switch leaves them alone until their
 * entry expires. An explicit Dismiss earns a long rest; a popup that simply
 * timed out gets a short one, so a still-hot channel can ask again later
 * instead of nagging every ten seconds.
 */
export class Dismissals {
  private until = new Map<string, number>();

  dismiss(id: string, now: number, ttlMs: number): void {
    this.until.set(id, now + ttlMs);
  }

  isDismissed(id: string, now: number): boolean {
    const expiry = this.until.get(id);
    if (expiry === undefined) return false;
    if (now >= expiry) {
      this.until.delete(id);
      return false;
    }
    return true;
  }

  sweep(now: number): void {
    this.until.forEach((expiry, id) => {
      if (now >= expiry) this.until.delete(id);
    });
  }

  get size(): number {
    return this.until.size;
  }
}
